import { Field, NumericInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { DateTimeStyle } from 'Components/Layout/Grid/types';
import { IWorksheetComponent, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { getDryMassGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/As/1289_2_1_1/gridFieldSets';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';

let InitialDryingDryMassReadings: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const showSingleReadingSection = useSelector(
    pipe(
      createWorksheetSelector!('DryingTray.DryMassReadings'),
      (r) => (r?.length ?? 0) <= 1 && dryMassEntryOption === 'Never'
    )
  );

  return (
    <>
      {showSingleReadingSection ? (
        <ListFieldSection>
          <Field
            input={<NumericInput />}
            name="DryingTray.DryMassReadings.0.DrySoilAndContainerMass"
            // We do not show the dry mass calculated from the Tare + Dry mass, so we need to show its messages on this field
            additionalMessagePaths={['DryingTray.DryMassReadings.0.DrySoilMass']}
          />
        </ListFieldSection>
      ) : (
        <WorksheetGridFieldSection name="DryingTray.DryMassReadings">
          <WorksheetRecordGrid
            name="DryingTray.DryMassReadings"
            orientation={'vertical'}
            recordProps={{
              enforceAtLeastOneRecord: true,
              preventRemove: 'all-but-last',
              removeConfirm: {
                confirm: true,
                confirmTitle: 'Delete Dry Mass Reading',
                confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
                confirmButtonText: 'Delete',
              },
            }}
            fieldSet={getDryMassGridFieldSet(dryMassEntryOption, DateTimeStyle.Combined)}
          />
        </WorksheetGridFieldSection>
      )}
    </>
  );
};

InitialDryingDryMassReadings = withInjectedProps(InitialDryingDryMassReadings);

export { InitialDryingDryMassReadings };
export default InitialDryingDryMassReadings;
